import React from "react";
import { Ear, MessageCircle, PhoneCall } from "lucide-react";
import { useGetCallSupervisorSessionsQuery } from "@/store/rest_api";
import type { MonitorMode } from "@/model/interface/Monitor";

const MODE_ICON: Record<MonitorMode, React.ReactNode> = {
  LISTEN: <Ear className="h-3 w-3" />,
  WHISPER: <MessageCircle className="h-3 w-3" />,
  BARGE: <PhoneCall className="h-3 w-3" />,
};

const MODE_LABEL: Record<MonitorMode, string> = {
  LISTEN: "listened",
  WHISPER: "whispered",
  BARGE: "barged in",
};

export function CallSupervisorSessions({ callId }: { callId: string }) {
  const { data: sessions } = useGetCallSupervisorSessionsQuery(callId);

  if (!sessions?.length) {
    return null;
  }

  return (
    <div className="space-y-1">
      <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Supervision</div>
      {sessions.map((session) => (
        <div key={session.id} className="flex items-center gap-1.5 text-xs text-muted-foreground">
          {MODE_ICON[session.mode]}
          <span className="text-foreground">{session.supervisorName ?? "A supervisor"}</span>
          <span>{MODE_LABEL[session.mode]}</span>
          {session.joinedAt && <span>· {new Date(session.joinedAt).toLocaleString()}</span>}
        </div>
      ))}
    </div>
  );
}
